import usePublisher from 'api/usePublisher';
import { EChecklistTaskStatus, ETaskId, PublisherInfo } from 'common/contracts';

import { Spinner } from 'components/ui/spinner';

import { ESavingForm } from '../DeveloperSettings.types';

import { ProjectInfoSection } from './ProjectInfoSection';

interface IStoreProjectInfoSectionProps {
  storeId: string;
  storeName: string;
  savingForm: ESavingForm;
  setSavingForm: (form: ESavingForm) => void;
  isSuperAdmin: boolean;
  hasCategories: boolean;
  isWebStore: boolean;
  isWebCheckout: boolean;
  setTaskStatus: (taskId: ETaskId, status?: EChecklistTaskStatus) => void;
  onCopy: (value: string, label: string) => void;
}

export const StoreProjectInfoSection: React.FC<
  IStoreProjectInfoSectionProps
> = ({
  storeId,
  storeName,
  savingForm,
  setSavingForm,
  isSuperAdmin,
  hasCategories,
  isWebStore,
  isWebCheckout,
  setTaskStatus,
  onCopy
}) => {
  const { getPublisher, updatePublisher } = usePublisher(storeId);
  const publisherData = getPublisher?.data as PublisherInfo | undefined;
  const isLoading = getPublisher.isLoading;

  if (isLoading) {
    return (
      <div className="flex h-32 w-full items-center justify-center rounded-lg border border-gray-200 bg-white">
        <Spinner className="size-7" />
      </div>
    );
  }

  const storeDisplayName = publisherData?.companyName || storeName;

  return (
    <ProjectInfoSection
      publisherData={publisherData}
      updatePublisher={updatePublisher}
      getPublisher={getPublisher}
      savingForm={savingForm}
      setSavingForm={setSavingForm}
      isSuperAdmin={isSuperAdmin}
      hasCategories={hasCategories}
      isWebStore={isWebStore}
      isWebCheckout={isWebCheckout}
      setTaskStatus={setTaskStatus}
      onCopy={onCopy}
      title={`Store Info - ${storeDisplayName}`}
    />
  );
};
